import { useState } from "react";
import { useDispatch } from "react-redux";
import { sendFeedbackRequest } from "../../../reducer/bookingReducer";
import { message } from "antd";

const useFeedback = () => {
  const dispatch = useDispatch();
  const [isLoading, setLoading] = useState(false);

  const sendFeedback = async (payload) => {
    setLoading(true);
    try {
      const response = await dispatch(sendFeedbackRequest(payload)).unwrap();
      message.success("Feedback request sent successfully");
      return response;
    } catch (error) {
      console.log(error?.response?.data?.message || error.message);

      message.error(
        error?.response?.data?.message ||
          error.message ||
          "Something Went Wrong!",
      );
    } finally {
      setLoading(false);
    }
  };

  return { sendFeedback, isLoading };
};

export default useFeedback;
